"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgPasteOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M17.41 2H6v28h10v-2H8V4h8v8h8v2h2v-3.41zM18 5.41L22.59 10H18z" }),
        React.createElement("path", { d: "M19.71 16.71l-1.42-1.42-4.7 4.71 4.7 4.71 1.42-1.42-2.3-2.29H24v9h2V19h-8.59l2.3-2.29z" })));
}
exports.default = SvgPasteOutline;
//# sourceMappingURL=PasteOutline.js.map